import { c as _c } from "react/compiler-runtime";
import React from "react";
import style from "./AgreementsMenu.module.scss";
export enum AgreementsMenuOptions {
  ACTIVE_AGREEMENTS,
  INACTIVE_AGREEMENTS,
}
const AgreementsMenu: React.FC<{
  selected: AgreementsMenuOptions;
  activeLabel: string;
  inactiveLabel: string;
  onChange: (selected: AgreementsMenuOptions) => void;
}> = t0 => {
  const $ = _c(19);
  const {
    selected,
    activeLabel,
    inactiveLabel,
    onChange
  } = t0;
  const t1 = selected == AgreementsMenuOptions.ACTIVE_AGREEMENTS ? style["menu-selected"] : "";
  let t2;
  if ($[0] !== onChange) {
    t2 = () => onChange(AgreementsMenuOptions.ACTIVE_AGREEMENTS);
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== activeLabel) {
    t3 = <span>{activeLabel}</span>;
    $[2] = activeLabel;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = <li className={t1} onClick={t2}>{t3}</li>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = selected == AgreementsMenuOptions.INACTIVE_AGREEMENTS ? style["menu-selected"] : "";
  let t6;
  if ($[8] !== onChange) {
    t6 = () => onChange(AgreementsMenuOptions.INACTIVE_AGREEMENTS);
    $[8] = onChange;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== inactiveLabel) {
    t7 = <span>{inactiveLabel}</span>;
    $[10] = inactiveLabel;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = <li className={t5} onClick={t6}>{t7}</li>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t4 || $[17] !== t8) {
    t9 = <div className={style.menu}><ul>{t4}{t8}</ul></div>;
    $[16] = t4;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
export default AgreementsMenu;